export const toDateTimeString = (timestamp: string) => {
    return new Date(timestamp)
        .toLocaleString([], {
            timeZoneName: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
        })
        .replace(",", "");
};
